import { NotificationType, notificationStore } from "../store/notification";

const notificationDurationInMs = 4000; // 4 seconds

export const copyToClipboard = (
    content: string | undefined,
    identifier?: string,
    notificationMessage?: string,
): void => {
    if (content === undefined) {
        return; // Exit early if content is undefined
    }

    void (async () => {
        try {
            await navigator.clipboard.writeText(content);
            notificationStore
                .getState()
                .upsertNotification(
                    notificationMessage || "Copied to clipboard",
                    NotificationType.SUCCESS,
                    identifier,
                );
            setTimeout(() => {
                notificationStore
                    .getState()
                    .dismissNotification(identifier ?? "");
            }, notificationDurationInMs);
        } catch (e) {
            notificationStore
                .getState()
                .upsertNotification(
                    "Unable to copy to clipboard",
                    NotificationType.ERROR,
                );
        }
    })();
};
